import {Component, input} from '@angular/core';
import {NgClass} from "@angular/common";
import {Animal} from "src/app/infrastructure/moovement-api/models/asset";
import {
  AnimalButtonComponent
} from "src/app/presentation/main-view/information-center/animals/animal-button/animal-button.component";

@Component({
  selector: 'app-scheduled-animals',
  imports: [
    NgClass,
    AnimalButtonComponent
],
  templateUrl: './scheduled-animals.component.html',
  styleUrl: './scheduled-animals.component.css'
})
export class ScheduledAnimalsComponent {

  animals = input.required<Animal[]>();
  title = input.required<string>();
  icon = input.required<string>();

  open: boolean = false;

  toggle() {
    this.open = !this.open
  }
}
